<template>
  <div
    class="tw-relative tw-flex tw-w-full tw-flex-col tw-justify-center tw-gap-5 tw-px-4 tw-py-9 tw-text-start"
    :style="`background-color: var(--c-${vars.backgroundColor}); border-radius: var(--rounded); border: 1px solid var(--c-border);`"
  >
    <h4>{{ vars.titleText }}</h4>

    <div v-if="vars.photoImage" class="mb-6">
      <img :src="String(vars.photoImage)" alt="" class="w-full h-auto" />
    </div>
    
    <p class="mb-6" v-if="vars.descriptionText" v-html="String(vars.descriptionText)"></p>
    
    <nuxt-link
      v-if="vars.buttonLinkUrl"
      :external="true"
      :to="String(vars.buttonLinkUrl)" 
      :class="`n-${vars.buttonTypeText || 'primary'} n-btn tw-w-fit`"
    >
      {{ vars.buttonLabelText }}
    </nuxt-link>
  </div>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'TeamCard',
  mixins: [ComponentMixin],
});
</script>
